import { motion } from "framer-motion";
import { Navbar } from "../components/Navbar";
import { HeroSection } from "../components/HeroSection";
import { PainPointsSection } from "../components/PainPointsSection";
import { SolutionSection } from "../components/SolutionSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { ResultsSection } from "../components/ResultsSection";
import { AboutSection } from "../components/AboutSection";
import { DifferentialsSection } from "../components/DifferentialsSection";
import { PositioningSection } from "../components/PositioningSection";
import { FinalCtaSection } from "../components/FinalCtaSection";
import { Footer } from "../components/Footer";

export default function LandingPage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-[#050505]"
    >
      <Navbar />
      <main>
        <HeroSection />
        <PainPointsSection />
        <SolutionSection />
        <HowItWorksSection />
        <ResultsSection />
        <AboutSection />
        <DifferentialsSection />
        <PositioningSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </motion.div>
  );
}
